var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReturnBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 78,
    viewBox: "0 0 74 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 69,
    height: 73,
    rx: 2,
    fill: "#FFF3E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6,
    width: 67,
    height: 71,
    rx: 1,
    stroke: "#00013A",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 46,
    width: 47,
    height: 22,
    rx: 1,
    fill: "white",
    stroke: "#00013A",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 51H28",
    stroke: "#00013A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 63L43 60",
    stroke: "#00013A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 63L49 60",
    stroke: "#00013A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 54H28",
    stroke: "#00013A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46 63L46 60",
    stroke: "#00013A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52 63L52 60",
    stroke: "#00013A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 15.5,
    r: 12.5,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5 28C65.4036 28 71 22.4036 71 15.5C71 8.59644 65.4036 3 58.5 3C51.5964 3 46 8.59644 46 15.5C46 22.4036 51.5964 28 58.5 28ZM66.3125 11.3333C66.7307 11.7283 66.7496 12.3876 66.3546 12.8059L57.6948 21.4236C57.5016 21.6282 57.2338 21.7459 56.9524 21.7499C56.671 21.7539 56.3999 21.6439 56.2009 21.4449L50.9926 16.2366C50.5858 15.8298 50.5858 15.1702 50.9926 14.7634C51.3994 14.3566 52.0589 14.3566 52.4657 14.7634L56.9162 19.2139L64.84 11.3754C65.235 10.9572 65.8943 10.9383 66.3125 11.3333Z",
    fill: "#0BAA4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReturnBag);
export default __webpack_public_path__ + "static/media/icon-return-bag.83de9a1429d64467369e864ea254de81.svg";
export { ForwardRef as ReactComponent };